import PublishIcon from '@mui/icons-material/Publish';
import {Typography} from '@mui/material';

import classes from './DnDCTA.module.css';

export function DnDCTA() {
    return (
        <div className={classes.dragAndDropCTA}>
            <PublishIcon style={{fontSize: '40px'}} />
            <Typography variant='overline' style={{display: 'block'}}>
                .GPX, .KML, .KMZ, .FIT, .GeoJSON
            </Typography>

            <Typography variant='h4'>
                {'Drag and drop files anywhere'}
                <br />
                {'on the map to import data'}
            </Typography>
        </div>
    );
}
